import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { SubmitType } from '../../../../shared/models/submit.type';
import { ColumnsType } from '../../../models/columns-type.model';
import { DataSource } from '../../../models/data-source.modol';

@Component({
  selector: 'morva-replace-data-source-confirm-update',
  templateUrl: './replace-data-source-confirm-update.component.html',
  styleUrls: ['./replace-data-source-confirm-update.component.scss']
})
export class ReplaceDataSourceConfirmUpdateComponent implements OnDestroy {
  title: string;
  warnings: string[];
  submitState: SubmitType;
  subscriptions: Subscription[] = [];
  dataSource: DataSource;
  columnsTypes: ColumnsType;
  type: 'updateDatasourceData' | 'updateDatasourceColumnTypes';
  message: string;

  constructor(
      private dialogRef: NbDialogRef<any>,
    ) {
  }


  confirm(): void {
     this.dialogRef.close('confirmUpdate');
  }

  close(): void {
      this.dialogRef.close('declineUpdate');
  }

  ngOnDestroy(): void {
      this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
